export default __webpack_public_path__ + "static/media/aguas-del-valle.288a19dd.svg";